export enum AboutYouQuestionType {
  AYCitizenshipStatus = 'AYCitizenshipStatus',
  AYInvestments = 'AYInvestments',
}
